// Lightweight pub-sub so a status change made in Inbox.js can tell
// Sidebar.js's independently-polling ticket-count badge to refetch
// immediately, instead of waiting for its next ~15s poll -- same pattern
// used for the notification bell's unread count for the same reason
// (separate component instances, no shared state).
export const TICKET_COUNT_CHANGED_EVENT = "ticket-count-changed";

export const notifyTicketCountChanged = () => {
  window.dispatchEvent(new Event(TICKET_COUNT_CHANGED_EVENT));
};
